import getProgress from './progress';

export default {
  getProgress,
};
